import { Compass } from "lucide-react";

export const Logo = ({ size = "md", invert = false }) => {
    const sizes = {
        sm: { icon: 18, text: "text-xl" },
        md: { icon: 22, text: "text-2xl" },
        lg: { icon: 28, text: "text-3xl" },
    };
    const s = sizes[size] || sizes.md;
    return (
        <a href="/" data-testid="logo-link" className="flex items-center gap-2 group">
            <span
                className="relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-terracotta text-sand shadow-md shadow-terracotta/30 transition-transform duration-500 group-hover:rotate-[60deg]"
                aria-hidden="true"
            >
                <Compass size={s.icon} strokeWidth={2} />
            </span>
            <span
                className={`font-display font-semibold tracking-tight ${s.text} ${invert ? "text-sand" : "text-ink"}`}
            >
                werighty<span className="text-terracotta">.</span>
            </span>
        </a>
    );
};

export default Logo;
